import React from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import SellBanner from "../component/SellBanner";
import AboutBox from "../component/AboutBox";
import FAQ from "../component/FAQ";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import SellWithAgent from "../component/SellWithAgent";
import FindYourOwnAgent from "../component/FindYourOwnAgent";
import { usePageContent } from "../hooks/usePageContent"; 
import {ASSETS_URL} from "../api/constants";

function Sell() {
  const { content, loading } = usePageContent("sell");

  const section = React.useMemo(() => {
    try {
      return JSON.parse(content?.sell_section || "{}");
    } catch {
      return {};
    }
  }, [content]);

  return (
    <>
      <div className="main about-us-page">
        <Header />
        <SellBanner data={section.section_1} loading={loading} />
        <SellWithAgent data={section.section_2} loading={loading} />
        <FindYourOwnAgent data={section.section_3} loading={loading} />
        <FAQ data={section.section_4} loading={loading} />
        <ConnectAgentCTA data={section.section_5} loading={loading} />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default Sell;
